import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { authActions } from "../_store";
import { getStoredValue, setStoredValue } from "../_helpers/storageHelper";

const useIPAddress = () => {
  const [ip, setIp] = useState(getStoredValue("cachedIP"));
  const dispatch = useDispatch();

  useEffect(() => {
    const GetIPAddress = () => {
      const cachedIP = getStoredValue("cachedIP");
      if (cachedIP) {
        setIp(cachedIP);
      }
      dispatch(authActions.GetIPAddress()).then((x) => {
        if (x.payload.IpAddress) {
          setStoredValue("cachedIP", x.payload.IpAddress);
          setIp(x.payload.IpAddress);
        }
      });
    };

    GetIPAddress();
  }, [dispatch]);

  return ip;
};

export default useIPAddress;
